import React from 'react';
import * as S from './RpmBox.style';
import { useTranslation } from 'react-i18next';
import * as P from '../../../../../../../utils/pipes';
import Popup from 'reactjs-popup';
import { PatientNamePopup } from '../../../../../followUp/FollowUp.style';

function RpmBox({ user, callMinutes, rpmReports }) {
  const {
    t,
    i18n: { language },
  } = useTranslation('global');  

  const secondsToMinutes = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes < 10 ? '0' + minutes: minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  // get callMinutes percentage for the progress bar, assuming max is 40 minutes (2400 seconds)
  const getCallMinutesPercentage = (callMinutes) => {
    const maxSeconds = 40 * 60; // 40 minutes in seconds
    return Math.min((callMinutes / maxSeconds) * 100, 100);
  };



  return (
    <S.RpmBox>
      <div className='left-content'>
        <div className='img-container'>
          <img
            src={user.picture}
            alt=''
            className='patient-img'
          />
        </div>

        <div className='patient-info'>
            <Popup
              trigger={() => (
                <div
                  className="patient-info__name"
                >
                  {user.name + ' ' + user.lastname}
                </div>
              )}
              on={["hover"]}
              position="top center"
            >
              {() => (
                <PatientNamePopup>
                  {user.name + ' ' + user.lastname}
                </PatientNamePopup>
              )}
            </Popup>

          {/* <div className='patient-info__note'>
            Note: She usually does not answer calls after 5pm because at that she is busy with her kids.
          </div> */}
        </div>
      </div>

      <div className='center-content'>
        <div className='devices'>
          <div className='devices__count'>
            <i className="devices__count-icon icon zaia-i-clock"
            ></i>
            {rpmReports}
          </div>
          <div className='devices__label'>{t("aiNavigator.rpm.measurementsThisMonth")}</div>
        </div>
      </div>

      <div className='right-content'>
        <div className="calls">
          <div className="labels">
            <div className="labels__text">
              {t("aiNavigator.rpm.totalCalls")}  
            </div>
            <div className="labels__text">
              <i className="labels__text-icon icon zaia-i-phone"></i>
              {secondsToMinutes(callMinutes)} 
              {
                callMinutes > 60 
                ? t("globally.minutes")
                : t("globally.seconds")
              }
            </div>
          </div>
          <div className="bar">
            <div className="bar__content"
              style={{width: `${getCallMinutesPercentage(callMinutes)}%`}}
            ></div>
            <div className="bar__labels">
              <div className="bar__label">0 Min</div>
              <div className="bar__label">20 Min</div>
              <div className="bar__label">40 Min</div>
            </div>
          </div>
        </div>
      </div>
    </S.RpmBox>
  );
}

export default RpmBox;
